import { LocateFixed } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useGeolocation } from '@/lib/use-geolocation';

interface LocationInputProps {
  latitude: string;
  longitude: string;
  onChange: (coords: { latitude: string; longitude: string }) => void;
  label?: string;
}

export function LocationInput({ latitude, longitude, onChange, label = 'Location' }: LocationInputProps) {
  const { loading, error, getCurrentPosition } = useGeolocation();

  async function handleUseCurrent() {
    try {
      const { lat, lng } = await getCurrentPosition();
      onChange({ latitude: lat.toFixed(7), longitude: lng.toFixed(7) });
    } catch {
      // error surfaced via hook state
    }
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
        <Button type="button" variant="ghost" size="sm" onClick={handleUseCurrent} isLoading={loading}>
          <LocateFixed className="w-3.5 h-3.5" />
          Use Current Location
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Input
          type="number"
          step="any"
          value={latitude}
          onChange={(e) => onChange({ latitude: e.target.value, longitude })}
          placeholder="Latitude"
        />
        <Input
          type="number"
          step="any"
          value={longitude}
          onChange={(e) => onChange({ latitude, longitude: e.target.value })}
          placeholder="Longitude"
        />
      </div>
      {error && <p className="mt-1 text-xs text-error-600">{error}</p>}
    </div>
  );
}
